
const propertyTypes = {
  STRING: "string",
  NUMBER: "number",
  DATE: "date",
  RANGE: "range",
  NUMBER_RANGE: "number_range",
  TIME_RANGE: "time_range",
  TIME_NUMBER_RANGE: "time_number_range",
  KID: "kid",
  GKID: "gkid",
  VALUES: "values",
  FRAZIONAMENTO: "frazionamento",
  STRING_LIST: "string_list",
  RANGE_FLEX: "range_flex",
};

const properties = {

  nomeProperty: {
    code: "1",
    name: "Nome",
    description: "Nome commerciale del prodotto",
    order: 0,
    value: "",
    valueDescription: "",
    type: propertyTypes.STRING
  },
  emittenteProperty: {
    code: "2",
    name: "Emittente",
    description: "Ragione sociale dell'emittente",
    order: 1,
    value: "",
    valueDescription: "",
    type: propertyTypes.STRING
  },
  distributoreProperty: {
    code: "3",
    name: "Distributore",
    description: "Ragione sociale del distributore",
    order: 2,
    value: "",
    valueDescription: "",
    type: propertyTypes.STRING
  },
  mercatoProperty: {
    code: "",
    name: "Mercato",
    description: "Mercato di riferimento",
    order: 3,
    value: "",
    valueDescription: "",
    type: propertyTypes.STRING
  },
  destinatariProperty: {
    code: "",
    name: "Destinatari",
    description:
      "Indica i destinatari del prodotto: persone fisiche e/o persone giuridiche",
    order: 4,
    value: "",
    valueDescription: "",
    type: propertyTypes.STRING
  },
  canaleProperty: {
    code: "",
    name: "Canale",
    description: "Canale distributivo",
    order: 5,
    value: "",
    valueDescription: "",
    type: propertyTypes.STRING
  },
  tipoProdottoProperty: {
    code: "",
    name: "Tipo Prodotto",
    description: "Tipologia del prodotto da censire",
    order: 6,
    value: "",
    valueDescription: "",
    type: propertyTypes.STRING
  },
  tipoSottostantiProperty: {
    code: "",
    name: "Tipologia sottostanti contratto",
    description:
      "Indica il tipo di oggetti d'investimento previsti nell'offerta",
    order: 7,
    value: "",
    valueDescription: "",
    type: propertyTypes.STRING
  },
  edizioneProperty: {
    code: "8",
    name: "Edizione",
    description:
      "Edizione della documentazione contrattuale (DIP Aggiuntivo) al momento del censimento",
    order: 8,
    value: "",
    dateValue: null,
    valueDescription: "",
    type: propertyTypes.STRING
  },
  prodCommProperty: {
    code: "",
    name: "Prodotto in commercio",
    description:
      "Se valorizzato indica che il prodotto è commercializzato al momento dell'apertura della sua scheda in consultazione",
    order: 9,
    value: "",
    valueDescription: "",
    type: propertyTypes.STRING
  },
  inizioCommProperty: {
    code: "10a",
    name: "Inizio Commercializzazione",
    description: "Data di inizio della commercializzazione",
    order: 10,
    value: "",
    dateValue: null,
    valueDescription: "",
    type: propertyTypes.STRING
  },
  fineCommProperty: {
    code: "10b",
    name: "Fine Commercializzazione",
    description: "Data di fine commercializzazione",
    order: 11,
    value: "",
    dateValue: null,
    valueDescription: "",
    type: propertyTypes.STRING
  },
  tipoPremioProperty: {
    code: "",
    name: "Tipo Premio",
    description: "Modalità di pagamento del premio",
    order: 12,
    value: "",
    valueDescription: "",
    type: propertyTypes.STRING
  },
  prodCollegatoProperty: {
    code: "",
    name: "Prodotto collegato PIC/PAC",
    description:
      "Indica se un prodotto PIC è distribuito anche in versione PAC o viceversa",
    order: 13,
    value: "",
    valueDescription: "",
    type: propertyTypes.STRING
  },
  codProdCollegatoProperty: {
    code: "11c",
    name: "Codice prodotto collegato PIC/PAC",
    description: "Indica il codice univoco del prodotto collegato",
    order: 14,
    value: "",
    valueDescription: "",
    type: propertyTypes.STRING
  },
  relazioneProdCollegatoProperty: {
    code: "",
    name: "Relazione con prodotto collegato PIC/PAC",
    description:
      "Indica il tipo di rapporto tra il prodotto PIC/PAC oggetto di analisi e il prodotto collegato",
    order: 15,
    value: "",
    valueDescription: "",
    type: propertyTypes.STRING
  },
  orizzonteTemporaleProperty: {
    code: "12",
    name: "Orizzonte temporale suggerito KID (anni)",
    description: "Orizzonte temporale suggerito indicato nel KID",
    order: 16,
    value: "",
    valueDescription: "",
    type: propertyTypes.STRING
  },
  tipologiaDurationProperty: {
    code: "",
    name: "Tipologia Duration",
    description: "Definisce se il prodotto ha una scadenza o una durata",
    order: 17,
    value: "",
    valueDescription: "",
    type: propertyTypes.STRING,
  },
  dataScadenzaProperty: {
    code: "14",
    name: "Data di scadenza",
    description: "Riporta un valore numerico riferito al precedente campo",
    order: 18,
    value: "",
    dateValue: null,
    valueDescription: "",
    type: propertyTypes.STRING,
    rangeValues: [
      {
        order: 0,
        from: "",
        to: "",
        value: "",
      }
    ]
  },
  importoMinimoProperty: {
    code: "15",
    name: "Importo minimo del premio",
    description: "La soglia di accesso minima per il premio",
    order: 19,
    value: "",
    valueDescription: "",
    type: propertyTypes.STRING
  },
  importoMassimoProperty: {
    code: "16",
    name: "Importo massimo del premio",
    description: "L'importo massimo del premio",
    order: 20,
    value: "",
    valueDescription: "",
    type: propertyTypes.STRING
  },
  retrocessioneUpfrontProperty: {
    code: "17",
    name: "Retrocessione al distributore Upfront Fee(%)",
    description: "Percentuale del caricamento pagata al distributore",
    order: 21,
    value: "",
    valueDescription: "",
    type: propertyTypes.STRING
  },
  retrocessioneGestSepProperty: {
    code: "18",
    name: "Retrocessione al distributore Gestione Separata(%)",
    description:
      "Percentuale del costo di gestione assicurativa pagata al distributore",
    order: 22,
    value: "",
    valueDescription: "",
    type: propertyTypes.STRING
  },
  retrocessioneRamIIIProperty: {
    code: "19",
    name: "Retrocessione al distributore Ramo III(%)",
    description:
      "Percentuale del costo di gestione assicurativa pagata al distributore",
    order: 23,
    value: "",
    valueDescription: "",
    type: propertyTypes.STRING
  },
  gsWeightMinProperty: {
    code: "20",
    name: "GS Weight Min(%)",
    description:
      "Possibile investimento minimo nella Gestione Separata concesso dal prodotto",
    order: 24,
    value: "",
    valueDescription: "",
    type: propertyTypes.STRING
  },
  gsWeightMaxProperty: {
    code: "21",
    name: "GS Weight Max(%)",
    description:
      "Possibile investimento massimo nella Gestione Separata concesso dal prodotto",
    order: 25,
    value: "",
    valueDescription: "",
    type: propertyTypes.STRING
  },
  tipoCalcoloBonusIngressoProperty: {
    code: "",
    name: "Tipologia calcolo Bonus Ingresso",
    description: "Indica le modalità di calcolo del bonus",
    order: 26,
    value: "",
    valueDescription: "",
    type: propertyTypes.STRING
  },
  bonusIngressoProperty: {
    code: "23",
    name: "Bonus Ingresso",
    description: "Parametri relativi al bonus",
    order: 27,
    value: "",
    valueDescription: "",
    type: propertyTypes.STRING,
    rangeValues: [
      {
        order: 0,
        from: "",
        to: "",
        value: ""
      }
    ]
  },
  tipoCalcoloBonusFedeltaProperty: {
    code: "",
    name: "Tipologia calcolo Bonus Fedeltà",
    description: "Indica se il bonus è riferito ai premi netti versati o al montante",
    order: 28,
    value: "",
    valueDescription: "",
    type: propertyTypes.STRING
  },
  bonusFedeltaProperty: {
    code: "25",
    name: "Bonus Fedeltà",
    description: "Parametri realativi al bonus",
    order: 29,
    value: "",
    valueDescription: "",
    rangeValues: [
      {
        order: 0,
        from: "",
        to: "",
        value: ""
      }
    ],
    type: propertyTypes.STRING,
  },
  speseAmministrativeAperturaContrattoProperty: {
    code: "26",
    name: "Spese Amministrative Apertura Contratto(€)",
    description: "Spesa in euro",
    order: 30,
    value: "",
    valueDescription: "",
    type: propertyTypes.STRING
  },
  speseAmministrativeVersamentoPACProperty: {
    code: "27",
    name: "Spese Amministrative Versamento PAC(€)",
    description: "Spesa in euro",
    order: 31,
    value: "",
    valueDescription: "",
    type: propertyTypes.STRING
  },
  tipologiaUpfrontFeeProperty: {
    code: "",
    name: "Tipologia Upfront Fee",
    description: "Criterio di applicazione del caricamento iniziale",
    order: 31,
    value: "",
    valueDescription: "",
    type: propertyTypes.STRING
  },
  upfrontFeeRangeProperty: {
    code: "29",
    name: "Upfront Fee Range",
    description: "Parametri relativi al caricamento iniziale",
    order: 32,
    value: "",
    valueDescription: "",
    rangeValues: [
      {
        order: 0,
        from: "",
        to: "",
        value: ""
      }
    ],
    type: propertyTypes.STRING
  },
  tipoCommGestioneSeparataProperty: {
    code: "",
    name: "Tipologia Commissione Gestione Separata",
    description: "Criterio di applicazione della commissione di gestione assicurativa",
    order: 33,
    value: "",
    valueDescription: "",
    type: propertyTypes.STRING
  },
  commGestioneSeparataProperty: {
    code: "31",
    name: "Commissione Gestione Separata",
    description: "Parametri relativi alla commissione di gestione assicurativa",
    order: 34,
    value: "",
    valueDescription: "",
    rangeValues: [
      {
        order: 0,
        from: "",
        to: "",
        value: ""
      }
    ],
    type: propertyTypes.STRING,
  },
  tipoCommFondiInterniAzionariProperty: {
    code: "",
    name: "Tipologia Commissione Fondi Interni Azionari",
    description: "Criterio di applicazione della commissione di gestione assicurativa",
    order: 35,
    value: "",
    valueDescription: "",
    type: propertyTypes.STRING,
    prefill: false
  },

  commFondiInterniAzionariProperty: {
    code: "33",
    name: "Commissione Fondi Interni Azionari",
    description: "Parametri relativi alla commissione di gestione assicurativa",
    order: 36,
    value: "",
    valueDescription: "",
    rangeValues: [
      {
        order: 0,
        from: "",
        to: "",
        value: ""
      }
    ],
    type: propertyTypes.STRING,
  },
  tipoCommFondiInterniObbligazionariProperty: {
    code: "",
    name: "Tipologia Commissione Fondi Interni Obbligazionari",
    description: "Criterio di applicazione della commissione di gestione assicurativa",
    order: 37,
    value: "",
    valueDescription: "",
    type: propertyTypes.STRING,
    prefill: false
  },
  commFondiInterniObbligazionariProperty: {
    code: "35",
    name: "Commissione Fondi Interni Obbligazionari",
    description: "Parametri relativi alla commissione di gestione assicurativa",
    order: 38,
    value: "",
    valueDescription: "",
    rangeValues: [
      {
        order: 0,
        from: "",
        to: "",
        value: ""
      }
    ],
    type: propertyTypes.STRING,
  },
  tipoCommFondiInterniBilanciatiProperty: {
    code: "",
    name: "Tipologia Commissione Fondi Interni Bilanciati",
    description: "Criterio di applicazione della commissione di gestione assicurativa",
    order: 39,
    value: "",
    valueDescription: "",
    type: propertyTypes.STRING,
    prefill: false
  },
  commFondiInterniBilanciatiProperty: {
    code: "37",
    name: "Commissione Fondi Interni Bilanciati",
    description: "Parametri relativi alla commissione di gestione assicurativa",
    order: 40,
    value: "",
    valueDescription: "",
    rangeValues: [
      {
        order: 0,
        from: "",
        to: "",
        value: ""
      }
    ],
    type: propertyTypes.STRING,
  },
  tipoCommFondiInterniFlessibiliProperty: {
    code: "",
    name: "Tipologia Commissione Fondi Interni Flessibili",
    description: "Criterio di applicazione della commissione di gestione assicurativa",
    order: 41,
    value: "",
    valueDescription: "",
    type: propertyTypes.STRING,
    prefill: false
  },
  commFondiInterniFlessibiliProperty: {
    code: "39",
    name: "Commissione Fondi Interni Flessibili",
    description: "Parametri relativi alla commissione di gestione assicurativa",
    order: 42,
    value: "",
    valueDescription: "",
    rangeValues: [
      {
        order: 0,
        from: "",
        to: "",
        value: ""
      }
    ],
    type: propertyTypes.STRING,
  },
  tipoCommFondiInterniMonetariProperty: {
    code: "",
    name: "Tipologia Commissione Fondi Interni Monetari",
    description: "Criterio di applicazione della commissione di gestione assicurativa",
    order: 43,
    value: "",
    valueDescription: "",
    type: propertyTypes.STRING,
    prefill: false
  },
  commFondiInterniMonetariProperty: {
    code: "41",
    name: "Commissione Fondi Interni Monetari",
    description: "Parametri relativi alla commissione di gestione assicurativa",
    order: 44,
    value: "",
    valueDescription: "",
    rangeValues: [
      {
        order: 0,
        from: "",
        to: "",
        value: ""
      }
    ],
    type: propertyTypes.STRING,
  },
  tipologiaCommissioneOICRProperty: {
    code: "",
    name: "Tipologia Commissione OICR",
    description: "Criterio di applicazione della commissione di gestione assicurativa",
    order: 45,
    value: "",
    valueDescription: "",
    type: propertyTypes.STRING,
    prefill: false
  },
  commissioneOICRAzionariProperty: {
    code: "43",
    name: "Commissione OICR Azionari",
    description: "Parametri relativi alla commissione di gestione assicurativa",
    order: 46,
    value: "",
    valueDescription: "",
    rangeValues: [
      {
        order: 0,
        from: "",
        to: "",
        value: ""
      }
    ],
    type: propertyTypes.STRING,
  },
  commissioneOICRObbligazionariProperty: {
    code: "44",
    name: "Commissione OICR Obbligazionari",
    description: "Parametri relativi alla commissione di gestione assicurativa",
    order: 47,
    value: "",
    valueDescription: "",
    rangeValues: [
      {
        order: 0,
        from: "",
        to: "",
        value: ""
      }
    ],
    type: propertyTypes.STRING,
  },
  commissioneOICRBilanciatiProperty: {
    code: "45",
    name: "Commissione OICR Bilanciati",
    description: "Parametri relativi alla commissione di gestione assicurativa",
    order: 48,
    value: "",
    valueDescription: "",
    rangeValues: [
      {
        order: 0,
        from: "",
        to: "",
        value: ""
      }
    ],
    type: propertyTypes.STRING,
  },
  commissioneOICRFlessibiliProperty: {
    code: "46",
    name: "Commissione OICR Flessibili",
    description: "Parametri relativi alla commissione di gestione assicurativa",
    order: 49,
    value: "",
    valueDescription: "",
    rangeValues: [
      {
        order: 0,
        from: "",
        to: "",
        value: ""
      }
    ],
    type: propertyTypes.STRING,
  },
  commissioneOICRMonetariProperty: {
    code: "47",
    name: "Commissione OICR Monetari",
    description: "Parametri relativi alla commissione di gestione assicurativa",
    order: 50,
    value: "",
    valueDescription: "",
    rangeValues: [
      {
        order: 0,
        from: "",
        to: "",
        value: ""
      }
    ],
    type: propertyTypes.STRING,
  },
  commissioniOverperformanceProperty: {
    code: "",
    name: "Commissioni Overperformance",
    description: "Se valorizzato indica che il prodotto prevede una commissione percentuale diretta che possa incrementare o ridursi in funzione delle perfomance raggiunte",
    order: 51,
    value: "",
    valueDescription: "",
    type: propertyTypes.STRING,
  },
  costoGaranziaMorteProperty: {
    code: "49",
    name: "Costo garanzia caso morte Ramo III (%)",
    description: "Il costo della TCM non opzinabile applicato alla componente di Ramo III",
    order: 52,
    value: "",
    valueDescription: "",
    type: propertyTypes.STRING,
  },
  applicazioneCommissioniUscitaProperty: {
    code: "",
    name: "Applicazione Commissioni di uscita",
    description: "Applicazione commissioni di uscita dal prodotto",
    order: 53,
    value: "",
    valueDescription: "",
    type: propertyTypes.STRING,
  },
  commissioneUscitaProperty: {
    code: "51",
    name: "Commissioni di uscita (%)",
    description: "Parametri relativi alle commissioni di uscita dal prodotto",
    order: 54,
    value: "",
    valueDescription: "",
    rangeValues: [
      {
        order: 0,
        from: "",
        to: "",
        value: ""
      }
    ],
    type: propertyTypes.STRING,
  },
  KIDProperty: {
    code: "",
    name: "KID",
    description: "Impiego dati KID",
    order: 55,
    value: "",
    valueDescription: "",
    type: propertyTypes.STRING,
  },
  scenarioKIDStressProperty: {
    code: "53",
    name: "Scenario KID - stress",
    description: "Possibile rimborso al netto dei costi",
    order: 56,
    value: "",
    valueDescription: "",
    rangeValues: [
      {
        order: 0,
        from: "",
        to: "",
        value: ""
      },
      {
        order: 1,
        from: "",
        to: "",
        value: ""
      },
      {
        order: 2,
        from: "",
        to: "",
        value: ""
      }
    ],
    type: propertyTypes.RANGE,
  },
  scenarioKIDSfavorevoleProperty: {
    code: "54",
    name: "Scenario KID - sfavorevole",
    description: "Possibile rimborso al netto dei costi",
    order: 57,
    value: "",
    valueDescription: "",
    rangeValues: [
      {
        order: 0,
        from: "",
        to: "",
        value: ""
      },
      {
        order: 1,
        from: "",
        to: "",
        value: ""
      },
      {
        order: 2,
        from: "",
        to: "",
        value: ""
      }
    ],
    type: propertyTypes.RANGE,
  },
  scenarioKIDModeratoProperty: {
    code: "55",
    name: "Scenario KID - Moderato",
    description: "Possibile rimborso al netto dei costi",
    order: 58,
    value: "",
    valueDescription: "",
    rangeValues: [
      {
        order: 0,
        from: "",
        to: "",
        value: ""
      },
      {
        order: 1,
        from: "",
        to: "",
        value: ""
      },
      {
        order: 2,
        from: "",
        to: "",
        value: ""
      }
    ],
    type: propertyTypes.RANGE,
  },
  scenarioKIDFavorevoleProperty: {
    code: "56",
    name: "Scenario KID - favorevole",
    description: "Possibile rimborso al netto dei costi",
    order: 59,
    value: "",
    valueDescription: "",
    rangeValues: [
      {
        order: 0,
        from: "",
        to: "",
        value: ""
      },
      {
        order: 1,
        from: "",
        to: "",
        value: ""
      },
      {
        order: 2,
        from: "",
        to: "",
        value: ""
      }
    ],
    type: propertyTypes.RANGE,
  },
  scenarioKIDCasoMorteProperty: {
    code: "57",
    name: "Scenario KID - Caso morte (o evento assicurato)",
    description: "Possibile rimborso al netto dei costi",
    order: 60,
    value: "",
    valueDescription: "",
    rangeValues: [
      {
        order: 0,
        from: "",
        to: "",
        value: ""
      },
      {
        order: 1,
        from: "",
        to: "",
        value: ""
      },
      {
        order: 2,
        from: "",
        to: "",
        value: ""
      }
    ],
    type: propertyTypes.RANGE,
  },
  GKIDProperty: {
    code: "58",
    name: "GKID",
    description: "Costi del prodotto e fascia di rischio",
    order: 61,
    value: "",
    valueDescription: "",
    gkid: {
      order :0,
      costs: [
        {
          from: "",
          to: ""
        },
        {
          from: "",
          to: ""
        },
        {
          from: "",
          to: ""
        },
      ],
      risk: {
        from: "",
        to: ""
      },
    },
    type: propertyTypes.GKID,
  },
  campoNoteProperty: {
    code: "59",
    name: "Note",
    description: "Campo note",
    order: 62,
    value: "",
    valueDescription: "",
    type: propertyTypes.STRING,
  },
};

export { propertyTypes };
export default properties;
